var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconProjCoord(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 14.5,
    r: 14.5,
    fill: "#212121"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.3722 15.9555C18.4069 16.4086 19.3366 17.071 20.1027 17.9011C20.2188 18.0294 20.2848 18.1953 20.2886 18.3683V21.2289C20.2886 21.4186 20.2132 21.6005 20.0791 21.7346C19.945 21.8687 19.7631 21.9441 19.5734 21.9441H8.60773C8.4197 21.9441 8.23923 21.87 8.10538 21.738C7.97154 21.6059 7.89509 21.4265 7.89258 21.2385V18.3778C7.89408 18.2015 7.96024 18.0319 8.07852 17.9011C8.84462 17.071 9.7743 16.4086 10.809 15.9555C11.8437 15.5025 12.961 15.2686 14.0906 15.2686C15.2201 15.2686 16.3375 15.5025 17.3722 15.9555Z",
    fill: "#6796CF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0913 14.3144C15.9345 14.3144 17.4287 12.8202 17.4287 10.977C17.4287 9.13385 15.9345 7.63965 14.0913 7.63965C12.2481 7.63965 10.7539 9.13385 10.7539 10.977C10.7539 12.8202 12.2481 14.3144 14.0913 14.3144Z",
    fill: "#6796CF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProjCoord);
export default __webpack_public_path__ + "static/media/IconProjCoord.f2ea565b6ce6d45f2903b0f0d0e3fff6.svg";
export { ForwardRef as ReactComponent };